module.exports = __webpack_public_path__ + "img/newpagebg1.2788d3d4.jpg";